/**
 * TanStack Query hook for the job-replay endpoint.
 *
 * Backend: `GET /api/jobs/{id}/steps` — SUPERVISOR+ because the
 * determinism telemetry columns can carry portal content that's
 * PHI-adjacent during write phases.
 */
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/apiClient";

export interface JobStep {
  id: string;
  phaseId: string | null;
  turnNumber: number;
  stepType: string;
  actionKind: string | null;
  actionTaken: string | null;
  actionTargetSelector: string | null;
  actionTargetX: number | null;
  actionTargetY: number | null;
  actionInputText: string | null;
  pageDomHash: string | null;
  tookRetry: boolean;
  modelUsed: string | null;
  inputTokens: number | null;
  outputTokens: number | null;
  errorMessage: string | null;
  modelConfidence: number | null;
  screenshotBlobRef: string | null;
  promptBlobRef: string | null;
  responseBlobRef: string | null;
  occurredAt: string | null;
}

export interface JobStepsPayload {
  items: JobStep[];
  total: number;
  jobId: string;
}

export function useJobSteps(jobId: string | undefined) {
  return useQuery<JobStepsPayload>({
    queryKey: ["jobs", jobId, "steps"],
    queryFn: () => apiFetch(`/jobs/${jobId}/steps`),
    enabled: Boolean(jobId),
    // Completed jobs don't change; cache for the session. Supervisors
    // who want a refresh can hit the reload button.
    staleTime: 60_000,
  });
}
